import React, { Suspense } from 'react';
import ViewContainer from "./ViewContainer";

const ViewEvaluation = (props) => {
    return (
        <ViewContainer {...props} />
    );
};

export default ViewEvaluation;